module.exports = __webpack_public_path__ + "static/media/wallet.0fe262e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/wallet.svg
// module id = 230
// module chunks = 0